import React, { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Card } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./carousel.css";
import SwiperCore from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

SwiperCore.use([Navigation, Pagination, Autoplay]);

const { Meta } = Card;

const cardData = [
  { type: "Feedback", appName: "Microsoft Teams Video room", description: "Insufficient Equipment / Facilities" },
  { type: "Action Taken", appName: "Microsoft Teams Video room", description: "Implemented MTR Global Support Model" },
  { type: "Feedback", appName: "Mobile telephony", description: "24/7, fast support needed" },
  { type: "Action Taken", appName: "Mobile telephony", description: "Boost self-service (QRG, KBI articles)" },
  { type: "Feedback", appName: "Mobile telephony", description: "Device replacement" },
  { type: "Action Taken", appName: "Mobile telephony", description: "Mobile Device Reuse Program" },
  { type: "Feedback", appName: "Office network connectivity", description: "Inconsistent Performance" },
  { type: "Action Taken", appName: "Office network connectivity", description: "Reaching out to users to understand their issues" },
  { type: "Feedback", appName: "Office network connectivity", description: "Connectivity and Stability Issues" },
  { type: "Action Taken", appName: "Office network connectivity", description: "Reaching out to users to understand their issues" },
  { type: "Feedback", appName: "Philips Personal Computer systems", description: "NAM survey response is still red" },
  { type: "Action Taken", appName: "Philips Personal Computer systems", description: "Deep dive workshop is planned" },
];

const MultiCardSwiper = () => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const swiperRef = useRef(null);

  const updateNavigationState = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleMouseEnter = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.stop();
    }
  };

  const handleMouseLeave = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start();
    }
  };

  return (
    <div
      className="carousel-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Swiper Component */}
      <Swiper
        slidesPerView={4}
        slidesPerGroup={4}
        spaceBetween={14}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
        }}
        pagination={{ clickable: true}} 
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next",
        }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => updateNavigationState(swiper)}
        breakpoints={{
          1200: { slidesPerView: 4 },
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
        }}
      >
        {cardData.map((card, index) => (
          <SwiperSlide key={index}>
            <Card
              hoverable
              className={`custom-card ${
                card.type === "Feedback" ? "feedback-card" : "action-card"
              }`}
            >
              <Meta
                title={<span
                  className={`card-title ${
                    card.type === "Feedback" ? "feedback" : "action"
                  }`}
                >
                  {card.type || "Information"}
                </span>}
                description={
                  <div>
                    <strong className="card-app-name">{card.appName}</strong>
                    <p className="card-description">{card.description}</p>
                  </div>
                }
              />
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        className={`custom-prev custom-nav-button ${isBeginning ? "disabled" : ""}`}
        onClick={() => !isBeginning && swiperRef.current.slidePrev()}
      >
        <LeftOutlined />
      </div>
      <div
        className={`custom-next custom-nav-button ${isEnd ? "disabled" : ""}`}
        onClick={() => !isEnd && swiperRef.current.slideNext()}
      >
        <RightOutlined />
      </div>
    </div>
  );
};

export default MultiCardSwiper;
